import clsx from 'clsx';
import { HTMLAttributes, ReactNode } from 'react';
import Icon from '../Icon';
import Typography from '../Typography';

type Size = `small` | `medium` | `large`;

const SIZE_MAPS: Record<Size, string> = {
  small: `w-4 h-4`,
  medium: `w-6 h-6`,
  large: `w-8 h-8`,
};

export type IconButtonProps = {
  size?: Size;
  children?: ReactNode;
} & HTMLAttributes<HTMLButtonElement>;

/**
 * @component IconButton
 */
function IconButton({
  size = `medium`,
  children,
  className,
  ...rest
}: IconButtonProps) {
  const rootClasses = clsx(
    `cursor-pointer transition select-none font-medium focus:outline-none flex flex-row items-center justify-center rounded-lg`,
    SIZE_MAPS[size],
    className,
  );
  return (
    <Typography as="button" className={rootClasses} {...rest}>
      {children}
    </Typography>
  );
}

export default IconButton;
